import React, { useEffect, useState } from 'react';
import post from '../../utils/apiService';
import CustomSelect from './CustomSelect';
import { useLocation } from 'react-router-dom';

const Breadcrumb = (props) => {
    const userRole = localStorage.getItem("user_roles");
	const merchantDropdownDisable = localStorage.getItem("merchant_menu_disable");
    const [merchantId, setMerchantId] = useState(localStorage.getItem("using_merchant_id") ?? localStorage.getItem("my_merchant_id"));
    const [merchantName, setMerchantName] = useState(localStorage.getItem("using_merchant_title") ?? localStorage.getItem("my_merchant_title"));
	const [merchantCode, setMerchantCode] = useState(localStorage.getItem("using_merchant_code") ?? localStorage.getItem("my_merchant_code"));
    const [merchantData, setMerchantData] = useState([]);
	
	// const [merchantMenuDisable, setMerchantMenuDisable] = useState(merchantDropdownDisable == "true" ? true : false);
	const [merchantMenuDisable, setMerchantMenuDisable] = useState(userRole === 'sa' ? false : true);
	const location = useLocation();
	
    // const allOption = userRole === 'sa' ? true : false;
	const allOption = false;
	
	// const merchantMenuDisable = userRole === 'sa' && merchantDropdownDisable === 'false' ? false : true;


    const handleDataFromChild = (name, value, code) => {
		
		console.log(" In Breadcrumb handleDataFromChild " + value.toString() ); 
		
		
		
        setMerchantId(value);
        setMerchantName(name);
		setMerchantCode(code); 
        localStorage.setItem("using_merchant_id", value)
        localStorage.setItem("using_merchant_title", name)
		localStorage.setItem("using_merchant_code", code)
        props.sendDataToParent(value, name);
		
		/*
		console.log("merchantDropdownDisable: " + merchantDropdownDisable.toString() + " " + (typeof merchantDropdownDisable)); 
		
		var merchantDropdownDisable_t = localStorage.getItem("merchant_menu_disable"); 
		
		console.log("merchantDropdownDisable_t: " + merchantDropdownDisable_t.toString() ); 
		
		if (merchantDropdownDisable_t == "true")
			setMerchantMenuDisable(true); 
		else 
			setMerchantMenuDisable(false); 
		*/

		
    };


    useEffect(() => {
        const fetchData = async () => {
			
			console.log(" In Breadcrumb fetchData"); 
			// console.log(userRole); 
            try {
                let responseData = {}; 
				
				if (userRole === 'sa') 
					responseData = await post('merchant/');
				else 
					responseData = await post('merchant/', {"merchant_id": merchantId});
				
                const merchantData = responseData.merchants;
                setMerchantData(merchantData);
				
				// console.log(merchantData); 
				
				// console.log(merchantData); 
                setMerchantId(merchantId ? merchantId: merchantData[0].merchant_id);
                setMerchantName(merchantName ? merchantName: merchantData[0].company_name);
				setMerchantCode(merchantCode ? merchantCode: merchantData[0].merchant_code);
				
				/*
				var merchantDropdownDisable_t = localStorage.getItem("merchant_menu_disable"); 
				if (merchantDropdownDisable_t == "true")
					setMerchantMenuDisable(true); 
				else 
					setMerchantMenuDisable(false); 
				*/
				
				
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchData();
        return () => {
        };
    }, [merchantId, location.pathname]);

    useEffect(() => {
        handleDataFromChild(merchantName, merchantId, merchantCode);
        return () => {
        };
    }, [merchantId, merchantName, merchantCode]);


    return (
        <div className="row clearfix">
            <div className="col-lg-12">
                <div className="card">
                    <div className="body block-header">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <ul className="breadcrumb p-l-0 p-b-0 ">
                                    <li className="breadcrumb-item pt-4">
                                        <a href="/" className=""><i className="icon-home mr-2"></i> 
                                            Dashboard
                                        </a>
                                    </li>
                                </ul>
                            </div>
							
							{
							/*
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className=" row clearfix justify-content-end">
                                    <div className="col-6 col-lg-3 col-md-4">
                                        <p className="fs-2 p-1 mt-2">Merchant</p>
                                    </div>
                                    <div className="col-6 col-lg-6 col-md-8 pl-4 form-group fs-2" >
                                        <CustomSelect id={"merchant-id"} data={merchantData} selectedName={merchantName} selectedValue={merchantId}
                                        selectValueKey='merchant_id' selectNameKey="company_name" selectCodeKey="merchant_code" sendDataToParent={handleDataFromChild} all={allOption} ></CustomSelect>
                                    </div>
                                </div>
                            </div>
							*/
							}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Breadcrumb;
